<template>
  <div class="snackbar">
    <div class="snackbar-container is-animated slide-from-top inverse-scheme">
      <span class="blinking-red-dot"><div /></span>
      <span class="prompt">{{ prompt }}</span>
      <span class="counter caption-type">{{ recordingDurationText }}/05:00</span>
      <button class="flat-button" @click="stop" v-t>Stop</button>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import IntlMixin from 'vuemixins/intl_mixin'
export default {
  mixins: [IntlMixin],
  props: ['audioEnabled', 'recordingDurationText'],
  computed: {
    prompt() {
      return this.audioEnabled
        ? this.__('Recording screen with audio...')
        : this.__('Recording screen without audio...')
    },
  },
  methods: {
    stop() {
      this.$emit('stop')
    },
  },
}
</script>

<style lang="scss" scoped>
@import './../../assets/stylesheets/3/modules/all';
@import './../../assets/stylesheets/mixins/colors';
@keyframes blinker {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.snackbar {
  position: absolute;
  width: 100vw;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: $snackbar-zindex;

  .snackbar-container {
    margin: 8px;
    padding: 4px 8px;
    color: white;
    background-color: $neutral-color;
    border-radius: $default-border-radius;
    display: flex;
    @include shadow-z3;
    align-items: center;
    span {
      padding: 8px 8px;
      font-size: 14px;
      line-height: 1.4;
    }
  }
}

body > .snackbar {
  position: fixed;
}
.blinking-red-dot {
  padding-right: 4px;
  animation: blinker 1.5s cubic-bezier(0.5, 0, 1, 1) infinite alternate;
  div {
    width: 16px;
    height: 16px;
    background: $red;
    border-radius: 50%;
    padding: 0;
    margin: 0;
  }
}
</style>
